import React from 'react'
import Text from 'core/elements/Text'
import Button from 'core/elements/button'
import { deleteLoadBalancer, listOctaviaListener } from './actions'
import Modal from 'core/elements/modal'
import { useAppSelector } from 'app/store'
import { octaviaListenersSelector } from './selectors'
import useListAction from 'core/hooks/useListAction'
import FontAwesomeIcon from 'pf9-ui-components/built/components/FontAwesomeIcon'
import { makeStyles } from '@material-ui/styles'
import Theme from 'core/themes/model'
import clsx from 'clsx'
import DeleteDialog from 'core/components/DeleteDialog'

export default function DeleteLoadBalancerDialog({ rows, onClose }) {
  const classes = useStyles()
  useListAction(listOctaviaListener)
  const listenersDetails = useAppSelector(octaviaListenersSelector)

  // Collect associated Load Balancers
  const associatedLoadBalancers = rows?.filter((row) =>
    listenersDetails?.some((detail) => detail?.loadbalancers?.[0]?.id === row?.id),
  )

  const isLoadBalancerAssociated = associatedLoadBalancers?.length > 0
  const associatedLoadBalancerNames = associatedLoadBalancers?.map((row) => row?.name).join(', ')

  if (isLoadBalancerAssociated) {
    return (
      <Modal
        panel="dialog"
        open
        onClose={onClose}
        title={
          <div className={classes.root}>
            <FontAwesomeIcon solid className={clsx(classes.circleIcon, classes.circleError)}>
              circle-xmark
            </FontAwesomeIcon>
            <div className={classes.header}>Delete Load Balancer</div>
          </div>
        }
        footer={
          <Button variant="secondary" onClick={onClose}>
            Cancel
          </Button>
        }
      >
        <Text variant="body2">
          You cannot delete the following Load Balancer(s) because they are associated with a
          Listener(s). Please delete the associated Listener(s) first.
          <br />
          <strong>{associatedLoadBalancerNames}</strong>
        </Text>
      </Modal>
    )
  }

  return (
    <DeleteDialog
      rows={rows}
      onClose={onClose}
      deleteAction={deleteLoadBalancer}
      title="Delete Load Balancer(s)"
      resourceLabel="Load Balancers"
    />
  )
}

const useStyles = makeStyles<Theme>((theme) => ({
  header: {
    paddingLeft: theme.spacing(1),
  },
  root: {
    display: 'flex',
    flexFlow: 'row nowrap',
    alignItems: 'center',
  },
  circleIcon: {
    fontSize: '18px',
    color: '#fff',
  },
  circleError: {
    background: theme.palette.graphRed[100],
    color: theme.palette.graphRed[500],
  },
}))
